import { applyMiddleware, compose, createStore } from 'redux';
// import { createLogger } from 'redux-logger';
import createSagaMiddleware from 'redux-saga';

import reducer from './reducers';
import rootSaga from './sagas';

const composeEnhancers =
    typeof window === 'object' &&
      (window).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ?
	  (window).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({}) : compose;
/* const loggerMiddleware = createLogger(); */
const sagaMiddleware = createSagaMiddleware(rootSaga);

export default function configureStore(preloadedState) {
  const store = createStore(
    reducer,
    preloadedState,
    composeEnhancers(
      applyMiddleware(
        /* loggerMiddleware, */
        sagaMiddleware
      )
    )
  );

  sagaMiddleware.run(rootSaga);

  return store;
}
